export default {"src":"/_next/static/media/icon-ethereum.1cd301de.svg","height":45,"width":27,"blurWidth":0,"blurHeight":0};